<template>
  <b-card class="photo mb-3" tag="article" no-body @click="$emit('click')">
    <b-card-body>
      <b-img center :src="photo.url.preview" fluid />
      <b-link class="d-block">
        <div class="meta">
          <div class="mr-3">
            <font-awesome-icon :icon="['fas', 'heart']" />
            {{ photo.votes.count }}
          </div>
          <div>
            <font-awesome-icon :icon="['fas', 'comments']" />
            {{ photo.comments.length }}
          </div>
          <div class="date">
            <small>
              {{ photo.uploaded | small }}
            </small>
          </div>
        </div>
      </b-link>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { small } from '@/filters/date'

export default {
  name: 'photo-block',
  filters: {
    small
  },
  props: {
    photo: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    voting: false
  }),
  computed: {
    ...mapState('UserModule', {
      userID: 'id',
      isPriest: 'priest'
    }),
    ...mapState('ParishModule', {
      activeParish: 'current'
    })
  },
  methods: {

  }
}
</script>

<style lang="scss">
.photo {
  &.card {
    border: none;
    border-radius: 0;
  }

  .card-body {
    padding: 0;
    margin: 0;
    position: relative;

    img {
      max-height: 150px;
      width: 100%;
      height: 100%;
      object-fit: cover;

      filter: brightness(1);
    }

      .meta {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .date {
          position: absolute;
          bottom: 3px;
          right: 8px;
        }
      }
  }

  &:hover {
    img {
      filter: brightness(.6)
    }

    .meta {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: white;
    }
  }
}
</style>
